import React from 'react';
import { PropTypes as PT } from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import classes from './SearchDropdown.module.scss';

const ITEM_HEIGHT = 42;

export class SearchDropdownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.itemHeight = props.itemHeight ? props.itemHeight : ITEM_HEIGHT;
    this.containerHeight = this.itemHeight * this.props.maxItems + 2;
    this.handleClickOutside.bind(this);
  }

  handleClickOutside(evt) {
    if (evt.target !== this.props.buttonRef.getElementsByTagName('input')[0]) {
      this.props.clickOutsideHandler(false);
    }
  }

  render = () => (
    <div className={`${classes.expanded} ${classes.dropdownMenu}`} style={this.props.styles}>
      {this.props.menuComponent}
    </div>
  );
}

SearchDropdownMenu.propTypes = {
  clickOutsideHandler: PT.func.isRequired,
  menuComponent: PT.element.isRequired,
  buttonRef: PT.object,
  styles: PT.object.isRequired,
  maxItems: PT.number,
  itemHeight: PT.number
};

export default onClickOutside(SearchDropdownMenu);
